import { Toaster as Sonner } from 'sonner';

export function Toaster() {
  return (
    <Sonner
      position='top-center'
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          error:
            'group-[.toaster]:bg-destructive group-[.toaster]:text-destructive-foreground',
          success: 'group-[.toaster]:bg-green-600 group-[.toaster]:text-white',
        },
      }}
    />
  );
}
